import React, { Component } from 'react'; //different
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

var settings = {
    dots: true,
    infinite: true,
    slidesToShow: (window.innerWidth <= 760) ? 1 : 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 3000,
    cssEase: "linear"
};

class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }

    }


    render() {
        return (
            <div>
                <div
                    className="flicking-viewport"
                    style={{
                        userSelect: "none",
                        WebkitUserDrag: "none",
                        touchAction: "pan-y"
                    }}
                >
                    <Slider {...settings}>
                        <div
                            className="-slide-inner-wrapper  -slick-item slick-slide slick-cloned "
                            data-slick-index={-2}
                            aria-hidden="true"
                            tabIndex={-1}

                        >
                            <div className="-link-wrapper" style={{ paddingRight: "10px" }}>
                                <picture>
                                    <img
                                        className="img-fluid -slick-item -item-9"
                                        src="/build/web/igame-index-lobby-wm/img/9XGucci-Banner-1.jpg"
                                        alt="First slide"
                                        width={1200}
                                        height={590}
                                        style={{ borderRadius: "0.5rem !important" }}
                                    />
                                </picture>
                            </div>
                        </div>
                        <div
                            className="-slide-inner-wrapper  -slick-item slick-slide slick-cloned "
                            data-slick-index={-1}
                            aria-hidden="true"
                            tabIndex={-1}

                        >
                            <div className="-link-wrapper" style={{ paddingRight: "10px" }}>
                                <picture>
                                    <img
                                        className="img-fluid -slick-item -item-9"
                                        src="/build/web/igame-index-lobby-wm/img/9XGucci-Banner-2.jpg"
                                        alt="First slide"
                                        width={1200}
                                        height={590}
                                        style={{ borderRadius: "0.5rem !important" }}
                                    />
                                </picture>
                            </div>
                        </div>
                        <div
                            className="-slide-inner-wrapper  -slick-item slick-slide slick-cloned "
                            data-slick-index={-1}
                            aria-hidden="true"
                            tabIndex={-1}
                        >
                            <div className="-link-wrapper" style={{ paddingRight: "10px" }}>
                                <picture>
                                    <img
                                        className="img-fluid -slick-item -item-9"
                                        src="/build/web/igame-index-lobby-wm/img/9XGucci-Banner-3.jpg"
                                        alt="First slide"
                                        width={1200}
                                        height={590}
                                        style={{ borderRadius: "0.5rem !important" }}
                                    />
                                </picture>
                            </div>
                        </div>
                        <div
                            className="-slide-inner-wrapper  -slick-item slick-slide slick-cloned "
                            data-slick-index={-1}
                            aria-hidden="true"
                            tabIndex={-1}
                        >
                            <div className="-link-wrapper" style={{ paddingRight: "10px" }}>
                                <picture>
                                    <img
                                        className="img-fluid -slick-item -item-9"
                                        src="/build/web/igame-index-lobby-wm/img/9XGucci-Banner-4.jpg"
                                        alt="First slide"
                                        width={1200}
                                        height={590}
                                        style={{ borderRadius: "0.5rem !important" }}
                                    />
                                </picture>
                            </div>
                        </div>
                        <div
                            className="-slide-inner-wrapper  -slick-item slick-slide slick-cloned "
                            data-slick-index={-1}
                            aria-hidden="true"
                            tabIndex={-1}
                        >
                            <div className="-link-wrapper" style={{ paddingRight: "10px" }}>
                                <picture>
                                    <img
                                        className="img-fluid -slick-item -item-9"
                                        src="/build/web/igame-index-lobby-wm/img/9XGucci-Banner-5.jpg"
                                        alt="First slide"
                                        width={1200}
                                        height={590}
                                        style={{ borderRadius: "0.5rem !important" }}
                                    />
                                </picture>
                            </div>
                        </div>
                        <div
                            className="-slide-inner-wrapper  -slick-item slick-slide slick-cloned "
                            data-slick-index={-1}
                            aria-hidden="true"
                            tabIndex={-1}
                        >
                            <div className="-link-wrapper" style={{ paddingRight: "10px" }}>
                                <picture>
                                    <img
                                        className="img-fluid -slick-item -item-9"
                                        src="/build/web/igame-index-lobby-wm/img/9XGucci-Banner-6.jpg"
                                        alt="First slide"
                                        width={1200}
                                        height={590}
                                        style={{ borderRadius: "0.5rem !important" }}
                                    />
                                </picture>
                            </div>
                        </div>
                    </Slider >

                </div>
            </div>

        );
    }
}
export default App;
